import {makeObservable} from "mobx";

import {AppConfiguration} from "../core/config/app-configuration";
import {MapViewerConfiguration} from "../config/map-viewer-configuration";
import {AppState} from "../components/app/app-mobx";
import {MapState} from "../core/map-state";
import {UiState} from "../core/ui-state";
import {AbstractAppStore} from "../core/stores/abstract-app-store";

export interface MapViewerStoreProps {
    appConfig: AppConfiguration;
    mapViewerConfig: MapViewerConfiguration;
    appStore: AppState;
    mapStore: MapState;
    uiStore: UiState;
}

export class MapViewerStore extends AbstractAppStore {
    /* stores are injected by abstract app store. Do not add them here! */

    /* add app specific properties here. Do not forget to add as observable in constructor */

    constructor(props: MapViewerStoreProps) {

        super(props);
        makeObservable(this, {
            /* add app specific observables here */
        });

        /* add app specific functions here */
    }

}


